import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbsModule } from '@app/core/components/breadcrumbs/breadcrumbs.module';
import { PaginationModule } from '@app/core/components/pagination/pagination.module';
import { CoreModule } from '@app/core/core.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { ContentNotFoundModule } from '@app/shared';
import { MeetingsCardModule } from '@core/components/meeting-card/meetings-card.module';
import { QRCodeModule } from '@le2xx/angularx-qrcode';

import { OnUiButtonModule } from 'onclass-ui';
import { UserServiceCardFullModule } from '../user-service-card-full/user-service-card-full.module';
import { MeetingPageComponent } from './meeting-page.component';

@NgModule({
  imports: [
    LocaleSharedModule,
    CommonModule,
    BreadcrumbsModule,
    CoreModule,
    MeetingsCardModule,
    QRCodeModule,

    RouterModule,
    PaginationModule,
    UserServiceCardFullModule,
    ContentNotFoundModule,
    OnUiButtonModule,
  ],
  declarations: [MeetingPageComponent],
  exports: [MeetingPageComponent],
})
export class MeetingPageModule {}
